import axios from 'axios'

import { isCsrfFailure, refreshCsrfToken } from './csrfTokenStore'
import { getDefaultHeaders } from './httpUtils'

const http = axios.create({
  baseURL: API_BASE_URL || undefined,
  withCredentials: true,
})

// Every request needs the default headers (X-CSRFToken in particular) — not just
// the multipart helpers below. Without this, plain http.post/put/delete calls hit
// Django CSRF protection with "CSRF Failed: CSRF token missing".
http.interceptors.request.use((config) => ({
  ...config,
  headers: {
    ...getDefaultHeaders(),
    ...config.headers,
  },
}))

http.putFile = (url, fieldName, file, method, config = {}) => {
  method = (method && method.toLowerCase()) || 'put'
  const fd = new FormData()
  fd.append(fieldName, file)
  return http[method](url, fd, config)
}

http.sendMultipartForm = (url, form, method, config = {}) => {
  const fd = new FormData()
  Object.keys(form).map((elem) => fd.append(elem, form[elem]))
  return http[(method && method.toLowerCase()) || 'post'](url, fd, config)
}

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    const response = error.response
    const config = error.config
    if (config && !config._csrfRetried && isCsrfFailure(response?.status, response?.data)) {
      config._csrfRetried = true
      try {
        const token = await refreshCsrfToken()
        return await http({ ...config, headers: { ...config.headers, 'X-CSRFToken': token } })
      } catch (retryError) {
        // retry already went through this handler (maps to a message) or refresh failed
        return Promise.reject(typeof retryError === 'string' ? retryError : 'Error')
      }
    }
    const message = response?.data?.message || 'Error'
    return Promise.reject(message)
  }
)

export default http
